import "./index.scss"

import {scrollPage} from "./scripts/scrollPage";
import {toggleVideoSound} from "./scripts/toggleVideoSound";
import {createSliders} from "./scripts/createSliders";
import {showHeader} from "./scripts/showHeader";
import {reviewsAnimation} from "./scripts/reviewsAnimation";

window.addEventListener('DOMContentLoaded', function () {
  createSliders();
  amzn('trackEvent', 'SLKPageView');
});

document.querySelector('.btn-scroll').addEventListener('click', scrollPage);

document.querySelector('.btn-sound').addEventListener('click', toggleVideoSound);

document.addEventListener('scroll', function () {
  reviewsAnimation();
  showHeader();
})

document.querySelectorAll('.btn--play').forEach(btn => {
  btn.addEventListener('click', function () {
    amzn("trackEvent", "SLKPlayNow");
  });
})

document.querySelector('.btn-download').addEventListener('click', function () {
  amzn("trackEvent", "SLKPlayNow");
});

